export const EnergyEfficiencyYearlyViewMock = {
  startDate: '2023-01-01T00:00:00.000Z',
  endDate: '2023-12-01T00:00:00.000Z',
  unitOfMeasure: 'metric',
  monthsWithInMaintenance: [],
  data: [
    {
      parameter: 'energyKwh',
      series: [
        ['2023-01-01T00:00:00.000Z', 133777.2597],
        ['2023-02-01T00:00:00.000Z', 119880.2766],
        ['2023-03-01T00:00:00.000Z', 138214.5835],
        ['2023-04-01T00:00:00.000Z', 135848.7837],
        ['2023-05-01T00:00:00.000Z', 135215.139],
        ['2023-06-01T00:00:00.000Z', 157282.7354],
        ['2023-07-01T00:00:00.000Z', 174034.0237],
        ['2023-08-01T00:00:00.000Z', 190575.2172],
        ['2023-09-01T00:00:00.000Z', 145989.9024],
        ['2023-10-01T00:00:00.000Z', 153892.919],
        ['2023-11-01T00:00:00.000Z', 148246.6564],
        ['2023-12-01T00:00:00.000Z', 153981.3009],
      ],
    },
    {
      parameter: 'volumeM3',
      series: [
        ['2023-01-01T00:00:00.000Z', 1731671.6415],
        ['2023-02-01T00:00:00.000Z', 1603490.9047],
        ['2023-03-01T00:00:00.000Z', 1874192.061],
        ['2023-04-01T00:00:00.000Z', 1715341.7727],
        ['2023-05-01T00:00:00.000Z', 1674686.6236],
        ['2023-06-01T00:00:00.000Z', 1898608.8367],
        ['2023-07-01T00:00:00.000Z', 1994501.7197],
        ['2023-08-01T00:00:00.000Z', 2272196.4509],
        ['2023-09-01T00:00:00.000Z', 1933050.2845],
        ['2023-10-01T00:00:00.000Z', 2045132.5324],
        ['2023-11-01T00:00:00.000Z', 1803457.2916],
        ['2023-12-01T00:00:00.000Z', 2164099.5117],
      ],
    },
    {
      parameter: 'specificPower',
      series: [
        ['2023-01-01T00:00:00.000Z', 4.6352],
        ['2023-02-01T00:00:00.000Z', 4.4857],
        ['2023-03-01T00:00:00.000Z', 4.4248],
        ['2023-04-01T00:00:00.000Z', 4.7518],
        ['2023-05-01T00:00:00.000Z', 4.8444],
        ['2023-06-01T00:00:00.000Z', 4.9705],
        ['2023-07-01T00:00:00.000Z', 5.2354],
        ['2023-08-01T00:00:00.000Z', 5.0324],
        ['2023-09-01T00:00:00.000Z', 4.5314],
        ['2023-10-01T00:00:00.000Z', 4.5149],
        ['2023-11-01T00:00:00.000Z', 4.9321],
        ['2023-12-01T00:00:00.000Z', 4.2692],
      ],
    },
    {
      parameter: 'baselineSpecificPower',
      series: [
        ['2023-01-01T00:00:00.000Z', 8.6097],
        ['2023-02-01T00:00:00.000Z', 8.6097],
        ['2023-03-01T00:00:00.000Z', 8.6097],
        ['2023-04-01T00:00:00.000Z', 8.6097],
        ['2023-05-01T00:00:00.000Z', 8.6097],
        ['2023-06-01T00:00:00.000Z', 8.6097],
        ['2023-07-01T00:00:00.000Z', 8.6097],
        ['2023-08-01T00:00:00.000Z', 8.6097],
        ['2023-09-01T00:00:00.000Z', 8.6097],
        ['2023-10-01T00:00:00.000Z', 8.6097],
        ['2023-11-01T00:00:00.000Z', 8.6097],
        ['2023-12-01T00:00:00.000Z', 8.6097],
      ],
    },
    {
      parameter: 'baselineNormalizedEnergyKwh',
      series: [
        ['2023-01-01T00:00:00.000Z', 248486.6766],
        ['2023-02-01T00:00:00.000Z', 230093.3482],
        ['2023-03-01T00:00:00.000Z', 268937.6817],
        ['2023-04-01T00:00:00.000Z', 246143.4178],
        ['2023-05-01T00:00:00.000Z', 240309.5966],
        ['2023-06-01T00:00:00.000Z', 272441.3733],
        ['2023-07-01T00:00:00.000Z', 286201.5477],
        ['2023-08-01T00:00:00.000Z', 326049.426],
        ['2023-09-01T00:00:00.000Z', 277383.5579],
        ['2023-10-01T00:00:00.000Z', 293466.8295],
        ['2023-11-01T00:00:00.000Z', 258787.5774],
        ['2023-12-01T00:00:00.000Z', 310538.0274],
      ],
    },
    {
      parameter: 'co2MetricTons',
      series: [
        ['2023-01-01T00:00:00.000Z', 94.58052259848],
        ['2023-02-01T00:00:00.000Z', 84.75535553097204],
        ['2023-03-01T00:00:00.000Z', 97.71771055571477],
        ['2023-04-01T00:00:00.000Z', 96.04509010959792],
        ['2023-05-01T00:00:00.000Z', 95.59710329451003],
        ['2023-06-01T00:00:00.000Z', 111.1988939214348],
        ['2023-07-01T00:00:00.000Z', 123.04205474277391],
        ['2023-08-01T00:00:00.000Z', 134.73667858273325],
        ['2023-09-01T00:00:00.000Z', 103.21486096346396],
        ['2023-10-01T00:00:00.000Z', 108.8022937094401],
        ['2023-11-01T00:00:00.000Z', 104.8103860756959],
        ['2023-12-01T00:00:00.000Z', 108.86477974331963],
      ],
    },
  ],
  yearOffsetLimit: 2,
};
